import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';
import { BONUS_PRICE } from '../../../constants/defaults';

const FamilywizeFaq = () => {
  const { t } = useTranslation();
  return (
    <div className="familywizeFaq">
      <div className="faqContainer">
        <h2 className="textCenter">{t('Frequently asked questions')}:</h2>
        <div className="faqQuestionAnswer">
          <div className="faqColumn">
            <p>
              <label className="float-left fullwidth">
                <strong> {t('Question')}: </strong>
                {t('Does SingleCare work the same way as FamilyWize?')}
              </label>
              <span className="fullwidth">
                <strong> {t('Answer')}: </strong>
                {t(
                  'Yes, SingleCare and FamilyWize work the same way! Just search'
                )}
                {t(
                  'for your prescriptions and get a free coupon to bring to the'
                )}
                {t('pharmacy.')}
              </span>
            </p>
            <p>
              <label className="float-left fullwidth">
                <strong> {t('Question')}: </strong>
                {t('Is there an advantage to signing up for SingleCare?')}
              </label>
              <span className="fullwidth">
                <strong> {t('Answer')}: </strong>
                {t('Yes! When you sign up, you’ll automatically')}
                {t('get bonus savings added to your', {
                  bonusPrice: BONUS_PRICE
                })}
                {t('account to use towards your next eligible')}
                {t('prescription. SingleCare members can earn')}
                {t('more bonus savings just by filling prescriptions.')}
                {t('Terms and conditions apply.')}
              </span>
            </p>
          </div>
          <div className="faqColumn">
            <p>
              <label className="float-left fullwidth">
                <strong> {t('Question')}: </strong>
                {t('Does it cost anything?')}
              </label>
              <span className="fullwidth">
                <strong> {t('Answer')}: </strong>
                {t(
                  'No, SingleCare is free for anyone to use, just like FamilyWize.'
                )}
              </span>
            </p>
            <p>
              <label className="float-left fullwidth">
                <strong> {t('Question')}: </strong> {t('Do the cards expire?')}
              </label>
              <span className="fullwidth">
                <strong> {t('Answer')}: </strong>
                {t('No, SingleCare and FamilyWize cards do not expire.')}
              </span>
            </p>
          </div>
          <div className="faqColumn">
            <p>
              <label className="float-left fullwidth">
                <strong> {t('Question')}: </strong>{' '}
                {t('Can I still use my FamilyWize card?')}
              </label>
              <span className="fullwidth">
                <strong> {t('Answer')}: </strong>
                {t(
                  'Yes, you can still use your FamilyWize card to save on your prescription medications.'
                )}
              </span>
            </p>
            <p className="actionLinks">
              {t('Have any questions?')}&nbsp;
              <a href="mailto:support@singlecare.com">
                {t('Send us an email')}
              </a>
              &nbsp;
              <br className="mobile-only" />
              {t('or call')}&nbsp;
              <a href="tel:844-234-3057">844-234-3057</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FamilywizeFaq;
